const API_BASE = '/api/footer';

async function api(path, { method = 'GET', body } = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'include',
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export const FooterService = {
  // Public (published-only) — used site-wide by the live Footer component.
  getPublicContent: () => api(''),

  // Admin — all sections incl. drafts, for the editor.
  getAdminContent: () => api('/admin'),

  saveSection: (sectionKey, { content, status }) => api(
    `/${encodeURIComponent(sectionKey)}`,
    { method: 'PUT', body: { content: content || {}, status: status || 'published' } }
  ),
};

export default FooterService;
